import { Box, styled } from '@mui/material';

const ADMIN_MIN_WIDTH = '1024px';

export const StyledMainContainer = styled(Box)(() => ({
  minWidth: ADMIN_MIN_WIDTH,
  maxWidth: '100vw',
}));

export const StyledContentContainer = styled(Box)(() => ({
  padding: '64px 24px 23px 24px',
  top: '12px',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  minWidth: ADMIN_MIN_WIDTH,
}));
